/**
 * Fit Guide quiz engine.
 *
 * Shared Shuttle capability. Answers map to Shopify Search & Discovery
 * collection filter query params via a section-level filter map. Primary
 * path can end on an email gate (Klaviyo identify + configurable event).
 * Secondary path can redirect to a collection and skip that gate.
 *
 * Filter VALUES should be the live collection filter labels, not slugified
 * checkbox ids.
 */
(function (global) {
  'use strict';

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function splitValues(raw) {
    if (raw == null) return [];
    return String(raw)
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function appendFilters(list, param, value) {
    var values = Array.isArray(value) ? value : splitValues(value);
    if (!param || !values.length) return list;
    var next = list.slice();
    var existing = null;
    for (var i = 0; i < next.length; i++) {
      if (next[i].param === param) {
        existing = next[i];
        break;
      }
    }
    if (existing) {
      values.forEach(function (item) {
        if (existing.values.indexOf(item) === -1) existing.values.push(item);
      });
    } else {
      next.push({ param: param, values: values.slice() });
    }
    return next;
  }

  function resolveResultsBase(handle) {
    var raw = String(handle == null ? '' : handle).trim();
    if (!raw) return '/collections/all';
    if (raw.charAt(0) === '/') return raw;
    return '/collections/' + raw.replace(/^collections\//, '');
  }

  function resolveChoiceParam(choice, filterMap) {
    if (!choice) return '';
    var key = String(choice.filterKey || '').trim();
    var map = filterMap || {};
    if (key && key !== 'none' && key !== 'custom' && map[key]) {
      return map[key];
    }
    return choice.filterParam || '';
  }

  function finishModeForPath(path, config) {
    var cfg = config || {};
    if (path === 'womens') return cfg.secondaryPathFinish || 'redirect';
    if (path === 'mens') return cfg.primaryPathFinish || 'email_results';
    return cfg.primaryPathFinish || 'email_results';
  }

  function buildResultsUrl(basePath, filters) {
    var path = basePath || '/collections/all';
    var query = [];
    (filters || []).forEach(function (filter) {
      if (!filter || !filter.param) return;
      var values = Array.isArray(filter.values) ? filter.values : splitValues(filter.value);
      values.forEach(function (value) {
        if (!value) return;
        query.push(encodeURIComponent(filter.param) + '=' + encodeURIComponent(value));
      });
    });
    if (!query.length) return path;
    var join = path.indexOf('?') >= 0 ? '&' : '?';
    return path + join + query.join('&');
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
  }

  var ART_BY_ID = {
    c_mens: 'mens',
    c_womens: 'womens',
    c_narrow: 'narrow',
    c_medium: 'medium',
    c_wide: 'wide',
    c_extra_wide: 'extra_wide',
    c_square: 'square',
    c_rectangle: 'rectangle',
    c_wrap: 'wrap',
    c_round: 'round',
    c_light: 'lightweight',
    c_mid: 'midweight',
    c_heavy: 'heavyweight',
    c_full: 'full_coverage',
    c_safety: 'safety',
    c_slide: 'slide',
    c_pinch: 'pinch',
    c_too_small: 'too_small',
    c_too_big: 'too_big',
    c_sun: 'sunglasses',
    c_rxsun: 'rx_sunglasses',
    c_rxeye: 'eyeglasses',
    c_readers: 'readers',
    c_welcome_continue: 'june_first',
    c_metal: 'metal',
    c_oversized: 'oversized',
    c_retro: 'retro',
  };

  var ART_BY_LABEL = {
    mens: 'mens',
    men_s: 'mens',
    womens: 'womens',
    women_s: 'womens',
    narrow: 'narrow',
    medium: 'medium',
    wide: 'wide',
    extra_wide: 'extra_wide',
    square: 'square',
    rectangle: 'rectangle',
    wrap: 'wrap',
    round: 'round',
    lightweight: 'lightweight',
    midweight: 'midweight',
    midweight_classic_performance: 'midweight',
    heavyweight: 'heavyweight',
    full_coverage: 'full_coverage',
    safety: 'safety',
    safety_z87: 'safety',
    they_slide_down_my_nose: 'slide',
    they_pinch_at_the_temples: 'pinch',
    they_feel_too_small: 'too_small',
    they_feel_too_big: 'too_big',
    sunglasses: 'sunglasses',
    prescription_sunglasses: 'rx_sunglasses',
    prescription_eyeglasses: 'eyeglasses',
    eyeglasses: 'eyeglasses',
    readers: 'readers',
    metal: 'metal',
    oversized: 'oversized',
    retro: 'retro',
  };

  function illustrationKey(choice) {
    if (!choice) return '';
    var explicit = String(choice.illustration || '').trim();
    if (explicit) return explicit;
    var id = String(choice.id || '').toLowerCase();
    if (ART_BY_ID[id]) return ART_BY_ID[id];
    var label = slugify(choice.label);
    if (ART_BY_LABEL[label]) return ART_BY_LABEL[label];
    return label;
  }

  function artUrl(choice, artMap) {
    if (!choice) return '';
    if (choice.image) return choice.image;
    var key = illustrationKey(choice);
    var map = artMap || {};
    return map[key] || '';
  }

  function isStatementQuestion(question) {
    var choices = (question && question.choices) || [];
    if (!question || question.inputType !== 'single' || choices.length !== 1) return false;
    var only = choices[0];
    return only.action === 'next' || /^continue$/i.test(String(only.label || ''));
  }

  function questionsForPath(questions, path) {
    return (questions || []).filter(function (question) {
      return question.path === 'start' || question.path === path;
    });
  }

  function quizStepsForPath(questions, path) {
    var resolved = path === 'start' ? 'mens' : path;
    return questionsForPath(questions, resolved).filter(function (item) {
      return item.inputType !== 'email';
    });
  }

  function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function applyChoice(state, question, choice, filterMap) {
    var next = clone(state);
    next.answers[question.key] = next.answers[question.key] || [];

    if (choice.path && choice.path !== 'none') next.path = choice.path;

    var param = resolveChoiceParam(choice, filterMap);
    var isKlaviyoOnly =
      choice.action === 'klaviyo' ||
      (!param && !choice.redirectUrl && choice.action !== 'path' && choice.action !== 'filter');

    if (isKlaviyoOnly) {
      next.klaviyo[question.key] = next.klaviyo[question.key] || [];
      if (next.klaviyo[question.key].indexOf(choice.label) === -1) {
        next.klaviyo[question.key].push(choice.label);
      }
    }

    if (param && choice.filterValue) {
      next.filters = appendFilters(next.filters, param, choice.filterValue);
    }

    var recorded = {
      key: question.key,
      heading: question.heading,
      label: choice.label,
      action: choice.action || '',
    };
    var already = next.answers[question.key].some(function (item) {
      return item.label === choice.label;
    });
    if (!already) next.answers[question.key].push(recorded);

    if (choice.redirectUrl) next.redirectUrl = choice.redirectUrl;
    return next;
  }

  function applyMultiChoices(state, question, choices, filterMap) {
    var next = clone(state);
    (choices || []).forEach(function (choice) {
      next = applyChoice(next, question, choice, filterMap);
    });
    return next;
  }

  function profileFromState(state) {
    var profile = {
      fit_quiz_path: state.path || '',
    };
    Object.keys(state.answers || {}).forEach(function (key) {
      var labels = (state.answers[key] || []).map(function (item) {
        return item.label;
      });
      if (labels.length) profile['fit_quiz_' + slugify(key)] = labels.join(', ');
    });
    Object.keys(state.klaviyo || {}).forEach(function (key) {
      var labels = state.klaviyo[key] || [];
      if (labels.length) profile['fit_quiz_' + slugify(key)] = labels.join(', ');
    });
    return profile;
  }

  function eventFromState(state, resultsUrl) {
    var event = {
      Path: state.path || '',
      ResultsUrl: resultsUrl || '',
    };
    Object.keys(state.answers || {}).forEach(function (key) {
      event[key] = (state.answers[key] || []).map(function (item) {
        return item.label;
      });
    });
    Object.keys(state.klaviyo || {}).forEach(function (key) {
      if (!event[key]) event[key] = state.klaviyo[key];
    });
    (state.filters || []).forEach(function (filter) {
      event['filter:' + filter.param] = filter.values;
    });
    return event;
  }

  function isValidEmail(value) {
    return EMAIL_PATTERN.test(String(value || '').trim());
  }

  function waitForKlaviyo(timeoutMs) {
    return new Promise(function (resolve) {
      var started = Date.now();
      function check() {
        var k = global.klaviyo;
        if (k && (typeof k.identify === 'function' || typeof k.push === 'function' || typeof k.track === 'function')) {
          resolve(k);
          return;
        }
        if (Date.now() - started >= timeoutMs) {
          resolve(global.klaviyo || null);
          return;
        }
        setTimeout(check, 50);
      }
      check();
    });
  }

  function klaviyoIdentifyAndTrack(klaviyo, email, profile, eventName, eventBody) {
    var identifyPayload = Object.assign({ email: email, $email: email }, profile || {});
    if (!klaviyo) return false;
    try {
      if (typeof klaviyo.identify === 'function') {
        klaviyo.identify(identifyPayload);
      } else if (typeof klaviyo.push === 'function') {
        klaviyo.push(['identify', identifyPayload]);
      }
      if (typeof klaviyo.track === 'function') {
        klaviyo.track(eventName, eventBody || {});
      } else if (typeof klaviyo.push === 'function') {
        klaviyo.push(['track', eventName, eventBody || {}]);
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  var FitQuizEngine = {
    splitValues: splitValues,
    appendFilters: appendFilters,
    resolveResultsBase: resolveResultsBase,
    resolveChoiceParam: resolveChoiceParam,
    finishModeForPath: finishModeForPath,
    buildResultsUrl: buildResultsUrl,
    questionsForPath: questionsForPath,
    quizStepsForPath: quizStepsForPath,
    applyChoice: applyChoice,
    applyMultiChoices: applyMultiChoices,
    profileFromState: profileFromState,
    eventFromState: eventFromState,
    isValidEmail: isValidEmail,
    klaviyoIdentifyAndTrack: klaviyoIdentifyAndTrack,
    illustrationKey: illustrationKey,
    artUrl: artUrl,
    isStatementQuestion: isStatementQuestion,
  };
  global.FitQuizEngine = FitQuizEngine;
  global.MadsonFitQuiz = FitQuizEngine;

  if (typeof HTMLElement === 'undefined' || typeof customElements === 'undefined') return;
  if (customElements.get('fit-quiz')) return;

  class FitQuiz extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.config = this.readConfig();
      if (!this.config) return;

      this.bindUi();

      this.state = {
        path: 'start',
        stepIndex: 0,
        answers: {},
        klaviyo: {},
        filters: [],
        redirectUrl: '',
        history: [],
      };
      this._emailFallback = false;
      this._showingResults = false;

      this._onClick = this.onClick.bind(this);
      this._onChange = this.onChange.bind(this);
      this._onSubmit = this.onSubmit.bind(this);
      this._onKeydown = this.onKeydown.bind(this);
      this._onTouchStart = this.onTouchStart.bind(this);
      this._onTouchEnd = this.onTouchEnd.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.addEventListener('submit', this._onSubmit);
      this.addEventListener('keydown', this._onKeydown);
      this.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.addEventListener('touchend', this._onTouchEnd, { passive: true });
      document.documentElement.classList.add('fit-quiz-app');
      document.body.classList.add('fit-quiz-app');
      this.render();
      if (this.config.previewJump) this.runPreviewJump(this.config.previewJump);
    }

    runPreviewJump(jump) {
      var advanceIds = [];
      var selectId = '';
      if (jump === 'width') advanceIds = ['c_mens'];
      if (jump === 'width-wide') {
        advanceIds = ['c_mens'];
        selectId = 'c_wide';
      }
      if (jump === 'results') advanceIds = ['c_mens', 'c_wide', 'c_square', 'c_light', 'skip', 'c_sun'];
      var self = this;
      advanceIds.forEach(function (id) {
        if (id === 'skip') {
          self.advance();
          return;
        }
        var input = self.querySelector('[data-choice-id="' + id + '"]');
        if (!input) return;
        input.checked = true;
        self.selectSingle(id);
      });
      if (selectId) {
        var last = this.querySelector('[data-choice-id="' + selectId + '"]');
        if (last) {
          last.checked = true;
          last.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    bindUi() {
      this.live = this.querySelector('[data-fit-quiz-live]');
      this.progressEl = this.querySelector('[data-fit-quiz-progress]');
      this.segmentsEl = this.querySelector('[data-fit-quiz-segments]');
      this.countEl = this.querySelector('[data-fit-quiz-count]');
      this.kickerEl = this.querySelector('[data-fit-quiz-kicker]');
      this.stepRoot = this.querySelector('[data-fit-quiz-step]');
      this.backBtn = this.querySelector('[data-fit-quiz-back]');
      this.continueBtn = this.querySelector('[data-fit-quiz-continue]');
      this.continueLabelEl = this.querySelector('[data-fit-quiz-continue-label]');
      this.skipBtn = this.querySelector('[data-fit-quiz-skip]');
      this.statusEl = this.querySelector('[data-fit-quiz-status]');
      this.dockEl = this.querySelector('.fit-quiz__dock');
      this.dockHelpEl = this.querySelector('[data-fit-quiz-dock-help]');
      this.editBtn = this.querySelector('[data-fit-quiz-edit]');
      this.saveBtn = this.querySelector('[data-fit-quiz-save]');
      this.guideBtn = this.querySelector('[data-fit-quiz-guide]');
      this.sheetEl = this.querySelector('[data-fit-quiz-sheet]');
      this.sheetBodyEl = this.querySelector('[data-fit-quiz-sheet-body]');
      this.sheetCloseBtn = this.querySelector('[data-fit-quiz-sheet-close]');
      this.meterEl = this.querySelector('.fit-quiz__meter');
      this.dialedEl = this.querySelector('[data-fit-quiz-dialed]');
    }

    resetFromEditor() {
      this.config = this.readConfig();
      if (!this.config) return;
      this.bindUi();
      this.state = {
        path: 'start',
        stepIndex: 0,
        answers: {},
        klaviyo: {},
        filters: [],
        redirectUrl: '',
        history: [],
      };
      this._emailFallback = false;
      this._showingResults = false;
      if (!this._bound) this.connectedCallback();
      else this.render();
    }

    readConfig() {
      var node = this.querySelector('[data-fit-quiz-config]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (err) {
        return null;
      }
    }

    currentQuestions() {
      return questionsForPath(this.config.questions, this.state.path === 'start' ? 'start' : this.state.path);
    }

    currentQuestion() {
      return this.currentQuestions()[this.state.stepIndex] || null;
    }

    announce(message) {
      if (!this.live) return;
      this.live.textContent = message || '';
    }

    setStatus(message, isError) {
      if (!this.statusEl) return;
      this.statusEl.hidden = !message;
      this.statusEl.textContent = message || '';
      this.statusEl.classList.toggle('fit-quiz__status--error', Boolean(isError));
    }

    onClick(event) {
      var back = event.target.closest('[data-fit-quiz-back]');
      if (back) {
        event.preventDefault();
        this.goBack();
        return;
      }

      var skip = event.target.closest('[data-fit-quiz-skip]');
      if (skip) {
        event.preventDefault();
        this.advance();
        return;
      }

      var continueBtn = event.target.closest('[data-fit-quiz-continue]');
      if (continueBtn) {
        event.preventDefault();
        if (continueBtn.disabled) return;
        this.submitDock();
        return;
      }

      var edit = event.target.closest('[data-fit-quiz-edit]');
      if (edit) {
        event.preventDefault();
        this.leaveResults();
        return;
      }

      var save = event.target.closest('[data-fit-quiz-save]');
      if (save) {
        event.preventDefault();
        this.saveFitCard();
        return;
      }

      var reset = event.target.closest('[data-fit-quiz-reset]');
      if (reset) {
        event.preventDefault();
        this.resetFromEditor();
        return;
      }

      var guide = event.target.closest('[data-fit-quiz-guide]');
      if (guide) {
        event.preventDefault();
        this.openSheet('guide');
        return;
      }

      var widthHelp = event.target.closest('[data-fit-quiz-width-help]');
      if (widthHelp) {
        event.preventDefault();
        this.openSheet('width');
        return;
      }

      var sheetClose = event.target.closest('[data-fit-quiz-sheet-close]');
      if (sheetClose) {
        event.preventDefault();
        this.closeSheet();
        return;
      }

      if (event.target === this.sheetEl) {
        this.closeSheet();
      }
    }

    onChange(event) {
      var input = event.target.closest('[data-fit-quiz-choice]');
      if (!input) return;
      this.setStatus('', false);
      var question = this.currentQuestion();
      if (!question) return;
      this.syncDock();
    }

    onSubmit(event) {
      var form = event.target.closest('[data-fit-quiz-email]');
      if (!form) return;
      event.preventDefault();
      this.submitEmail(form);
    }

    onKeydown(event) {
      if (event.key !== 'Enter') return;
      var choice = event.target.closest('[data-fit-quiz-choice]');
      var question = this.currentQuestion();
      if (choice && question && question.inputType === 'multi') {
        event.preventDefault();
        choice.click();
        return;
      }
      if (event.target === this.continueBtn && !this.continueBtn.disabled) {
        event.preventDefault();
        this.submitDock();
      }
    }

    onTouchStart(event) {
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      this._touchX = touch.clientX;
      this._touchY = touch.clientY;
    }

    onTouchEnd(event) {
      if (this._touchX == null) return;
      var touch = event.changedTouches && event.changedTouches[0];
      var startX = this._touchX;
      var startY = this._touchY;
      this._touchX = null;
      this._touchY = null;
      if (!touch) return;
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (dx > 72 && Math.abs(dy) < 56 && startX < 56) this.goBack();
    }

    submitDock() {
      var question = this.currentQuestion();
      if (this._emailFallback || (question && question.inputType === 'email')) return;
      if (question && question.inputType === 'multi') {
        this.submitMulti();
        return;
      }
      this.submitSingle();
    }

    submitSingle() {
      var selected = this.querySelector('[data-fit-quiz-choice]:checked');
      if (!selected) {
        var message = this.config.singleRequiredError || 'Please choose one.';
        this.setStatus(message, true);
        this.announce(message);
        return;
      }
      this.selectSingle(selected.getAttribute('data-choice-id'));
    }

    selectSingle(choiceId) {
      var question = this.currentQuestion();
      if (!question) return;
      var choice = (question.choices || []).find(function (item) {
        return item.id === choiceId;
      });
      if (!choice) return;
      this.state.history.push(clone(this.state));
      this._emailFallback = false;
      this.state = applyChoice(this.state, question, choice, this.config.filterMap);
      if (choice.redirectUrl) {
        this.showResults();
        return;
      }
      this.advance();
    }

    submitMulti() {
      var question = this.currentQuestion();
      if (!question) return;
      var selected = Array.prototype.slice.call(this.querySelectorAll('[data-fit-quiz-choice]:checked'));
      if (!selected.length) {
        this.setStatus(this.config.multiRequiredError || 'Pick at least one, or skip.', true);
        this.announce(this.config.multiRequiredError || 'Pick at least one, or skip.');
        return;
      }
      var choices = selected
        .map(function (input) {
          var id = input.getAttribute('data-choice-id');
          return (question.choices || []).find(function (item) {
            return item.id === id;
          });
        })
        .filter(Boolean);
      this.state.history.push(clone(this.state));
      this._emailFallback = false;
      this.state = applyMultiChoices(this.state, question, choices, this.config.filterMap);
      this.advance();
    }

    submitEmail(form) {
      var emailInput = form.querySelector('[data-fit-quiz-email-input]');
      var consentInput = form.querySelector('[data-fit-quiz-consent]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      var consented = consentInput ? consentInput.checked : false;
      var question = this.currentQuestion();

      this.setStatus('', false);

      if (!isValidEmail(email)) {
        this.setStatus(this.config.emailError || 'Enter a valid email address.', true);
        if (emailInput) {
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.focus();
        }
        this.announce(this.config.emailError || 'Enter a valid email address.');
        return;
      }
      if (!consented) {
        this.setStatus(this.config.consentError || 'Agree to receive the quiz results to continue.', true);
        if (consentInput) consentInput.focus();
        this.announce(this.config.consentError || 'Agree to receive the quiz results to continue.');
        return;
      }

      if (emailInput) emailInput.setAttribute('aria-invalid', 'false');
      this.state.email = email;
      var answerKey = this._emailFallback ? 'email' : (question && question.key) || 'email';
      this.state.answers[answerKey] = [{ key: 'email', heading: 'Email', label: email }];

      var resultsUrl = this.state.redirectUrl || buildResultsUrl(this.config.resultsBase, this.state.filters);
      var eventName = this.config.klaviyoEvent || 'Fit Quiz Completed';
      var profile = profileFromState(this.state);
      var eventBody = eventFromState(this.state, resultsUrl);

      var self = this;
      waitForKlaviyo(1500).then(function (klaviyo) {
        klaviyoIdentifyAndTrack(klaviyo, email, profile, eventName, eventBody);
        self.setStatus('Fit card saved.', false);
        self.announce('Fit card saved. Your filtered collection is ready.');
        var form = self.stepRoot.querySelector('[data-fit-quiz-email]');
        if (form) form.hidden = true;
        if (!self._showingResults) self.navigate(resultsUrl);
      });
    }

    advance() {
      this.setStatus('', false);
      var questions = this.currentQuestions();
      var nextIndex = this.state.stepIndex + 1;
      var nextQuestion = questions[nextIndex];
      if (nextIndex >= questions.length || (nextQuestion && nextQuestion.inputType === 'email')) {
        this.completePath();
        return;
      }
      this.state.stepIndex = nextIndex;
      this.render();
    }

    completePath() {
      this.showResults();
    }

    showEmailFallback() {
      this._emailFallback = true;
      var question = {
        id: 'email-fallback',
        key: 'email',
        heading: this.config.emailHeading || 'Where should we send your results?',
        body: this.config.emailBody || '',
        consentLabel: this.config.emailConsentLabel,
        submitLabel: this.config.emailSubmitLabel,
        emailPlaceholder: this.config.emailPlaceholder,
        inputType: 'email',
      };
      this.stepRoot.innerHTML = this.emailMarkup(question);
      this.syncDock();
      this.setStatus('', false);
      this.announce(question.heading);
      var heading = this.stepRoot.querySelector('.fit-quiz__question');
      if (heading) heading.focus();
    }

    goBack() {
      if (this._showingResults) {
        this.leaveResults();
        return;
      }
      if (this._emailFallback) {
        this._emailFallback = false;
        this.render();
        this.announce('Previous question.');
        return;
      }
      var previous = this.state.history.pop();
      if (!previous) return;
      this.state = previous;
      this.render();
      this.announce('Previous question.');
    }

    leaveResults() {
      this._showingResults = false;
      var previous = this.state.history.pop();
      if (previous) this.state = previous;
      this.render();
      this.announce('Previous question.');
    }

    finish(url) {
      this.showResults();
    }

    showCalculating() {
      var heading = this.config.calculatingHeading || 'Finding your frames.';
      var body = this.config.calculatingBody || 'One moment.';
      this.stepRoot.innerHTML =
        '<div class="fit-quiz__calculating" role="status">' +
        '<p class="fit-quiz__kicker">' +
        escapeHtml(this.config.eyebrow || 'Fit Guide') +
        '</p>' +
        '<h2 class="fit-quiz__question">' +
        escapeHtml(heading) +
        '</h2>' +
        '<p class="fit-quiz__body">' +
        escapeHtml(body) +
        '</p>' +
        '</div>';
      this.syncDock(true);
      this.announce(heading);
    }

    navigate(url) {
      var delay = 0;
      try {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) delay = 450;
      } catch (err) {
        delay = 450;
      }
      window.setTimeout(function () {
        window.location.assign(url);
      }, delay);
    }

    padStep(n) {
      return n < 10 ? '0' + n : String(n);
    }

    quizSteps() {
      return quizStepsForPath(this.config.questions, this.state.path);
    }

    render() {
      if (this._showingResults) {
        this.renderResults();
        return;
      }

      var question = this.currentQuestion();
      if (!question) return;

      var quizSteps = this.quizSteps();
      var isEmailStep = question.inputType === 'email';
      var stepCount = Math.max(quizSteps.length, 1);
      var stepNumber = isEmailStep ? stepCount : Math.min(this.state.stepIndex + 1, stepCount);
      var progressLabel = 'Question ' + stepNumber + ' of ' + stepCount;
      if (this.progressEl) this.progressEl.textContent = progressLabel;
      if (this.countEl) this.countEl.textContent = this.padStep(stepNumber) + ' / ' + this.padStep(stepCount);
      if (this.meterEl) this.meterEl.classList.remove('is-done');
      if (this.kickerEl) {
        this.kickerEl.textContent =
          question.key === 'looking_for'
            ? this.config.eyebrow || 'Your next everyday pair starts here'
            : 'A little closer to your everyday pair';
      }
      if (this.segmentsEl) {
        var segs = '';
        var i;
        for (i = 1; i <= stepCount; i++) {
          var stateClass = i < stepNumber ? ' is-done' : i === stepNumber ? ' is-on' : '';
          segs += '<span class="fit-quiz__seg' + stateClass + '"></span>';
        }
        this.segmentsEl.innerHTML = segs;
        var meter = this.segmentsEl.parentElement;
        if (meter) {
          meter.setAttribute('aria-valuenow', String(stepNumber));
          meter.setAttribute('aria-valuemax', String(stepCount));
          meter.setAttribute('aria-label', progressLabel);
        }
      }
      this._emailFallback = false;
      if (question.inputType === 'email') {
        this.showResults();
        return;
      } else if (isStatementQuestion(question)) {
        this.stepRoot.innerHTML = this.statementMarkup(question);
      } else {
        this.stepRoot.innerHTML = this.questionMarkup(question);
      }

      this.syncDock();
      this.setStatus('', false);
      this.announce(question.heading + '. ' + progressLabel);

      var heading = this.stepRoot.querySelector('.fit-quiz__question');
      if (heading) heading.focus();
    }

    syncDock(hideAll) {
      var showingResults = this._showingResults;
      var question = this._emailFallback
        ? { inputType: 'email', skipLabel: '' }
        : this.currentQuestion();
      var isEmail = hideAll || showingResults || !question || question.inputType === 'email';
      var isStatement = question && isStatementQuestion(question);
      var isStart = Boolean(question && question.key === 'looking_for') && !showingResults;
      var isWidth = Boolean(question && question.key === 'face_width') && !showingResults;
      var selectedCount = this.querySelectorAll('[data-fit-quiz-choice]:checked').length;
      var showContinue = !isEmail;
      var canContinue = isStatement || selectedCount > 0;
      var showBack = !hideAll && !showingResults && this.state.history.length > 0;
      var showDockHelp = !hideAll && isStart;
      var skipLabel = question && question.skipLabel;
      var showDockSkip = !hideAll && !showingResults && !isWidth && Boolean(skipLabel);

      if (this.continueBtn) {
        this.continueBtn.hidden = !showContinue;
        this.continueBtn.disabled = !canContinue;
        var label = (question && question.continueLabel) || 'Continue';
        if (this.continueLabelEl) this.continueLabelEl.textContent = label;
        else this.continueBtn.textContent = label;
      }
      if (this.skipBtn) {
        this.skipBtn.hidden = !showDockSkip;
        this.skipBtn.textContent = skipLabel || '';
      }
      if (this.backBtn) {
        this.backBtn.hidden = !showBack;
      }
      if (this.editBtn) {
        this.editBtn.hidden = !showingResults;
      }
      if (this.saveBtn) {
        this.saveBtn.hidden = !showingResults;
      }
      if (this.dockHelpEl) {
        this.dockHelpEl.hidden = !showDockHelp;
      }
      if (this.dockEl) {
        this.dockEl.classList.toggle('fit-quiz__dock--start', showDockHelp);
        this.dockEl.classList.toggle('fit-quiz__dock--solo', !showBack && !showDockHelp && !showingResults);
        this.dockEl.classList.toggle('fit-quiz__dock--results', showingResults);
        this.dockEl.hidden = Boolean(hideAll);
      }
    }

    artForChoice(choice) {
      return artUrl(choice, this.config.art);
    }

    checkMarkup() {
      return (
        '<span class="fit-quiz__check" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" focusable="false"><path d="M5 10.4l3.2 3.2L15 6.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>'
      );
    }

    artMarkup(src, extraClass, eager) {
      var frameClass = 'fit-quiz__art-frame' + (extraClass ? ' ' + extraClass : '');
      var check = this.checkMarkup();
      if (!src) {
        return '<span class="' + frameClass + '" aria-hidden="true">' + check + '</span>';
      }
      return (
        '<span class="' +
        frameClass +
        '">' +
        '<img class="fit-quiz__art" src="' +
        escapeAttr(src) +
        '" alt="" width="880" height="880" decoding="async" loading="' +
        (eager ? 'eager' : 'lazy') +
        '">' +
        check +
        '</span>'
      );
    }

    sparkleMarkup() {
      return (
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M12 3.2l1.1 6.2L19 12l-5.9 2.6L12 20.8l-1.1-6.2L5 12l5.9-2.6L12 3.2z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
        '</svg>'
      );
    }

    titleHtml(heading) {
      var text = String(heading || '');
      if (text === 'Where should we start?') return 'Where should<br>we start?';
      if (text === 'A little room. A better fit.') return 'A little room.<br>A better fit.';
      var dot = text.indexOf('. ');
      if (dot > -1 && text.length > 22) {
        return escapeHtml(text.slice(0, dot + 1)) + '<br>' + escapeHtml(text.slice(dot + 2));
      }
      return escapeHtml(text);
    }

    questionMarkup(question) {
      var self = this;
      var isMulti = question.inputType === 'multi';
      var inputType = isMulti ? 'checkbox' : 'radio';
      var name = 'fit-quiz-' + question.id;
      var count = (question.choices || []).length;
      var isStart = question.key === 'looking_for' || (self.state.path === 'start' && self.state.stepIndex === 0);
      var isWidth = question.key === 'face_width';
      var body = question.body;
      var stepName =
        question.key === 'looking_for'
          ? 'Your style'
          : question.key === 'face_width'
            ? 'Your proportions'
            : question.key === 'shape'
              ? 'Your shape'
              : question.key === 'feel'
                ? 'Your feel'
                : question.key === 'dial_in'
                  ? 'Your notes'
                  : question.key === 'recommend'
                    ? 'Your pair'
                    : '';
      var note =
        question.key === 'looking_for'
          ? 'Six quick steps. All about you.'
          : question.key === 'face_width'
            ? 'Comfort starts with the right width.'
            : '';
      var choices = (question.choices || [])
        .map(function (choice) {
          var src = self.artForChoice(choice);
          var wide = !src;
          return (
            '<label class="fit-quiz__choice' +
            (wide ? ' fit-quiz__choice--wide' : '') +
            '">' +
            '<input class="fit-quiz__input" type="' +
            inputType +
            '" name="' +
            escapeAttr(name) +
            '" value="' +
            escapeAttr(choice.label) +
            '" data-fit-quiz-choice data-choice-id="' +
            escapeAttr(choice.id) +
            '">' +
            '<span class="fit-quiz__choice-ui">' +
            (wide
              ? '<span class="fit-quiz__mark" aria-hidden="true">' + self.sparkleMarkup() + '</span>'
              : self.artMarkup(src, '', isStart)) +
            '<span class="fit-quiz__choice-copy">' +
            '<span class="fit-quiz__choice-label">' +
            escapeHtml(choice.label) +
            '</span>' +
            (choice.help ? '<span class="fit-quiz__choice-help">' + escapeHtml(choice.help) + '</span>' : '') +
            '</span>' +
            (wide ? self.checkMarkup() : '') +
            '</span>' +
            '</label>'
          );
        })
        .join('');

      var widthTools = isWidth
        ? '<div class="fit-quiz__width-tools">' +
          '<button type="button" class="fit-quiz__width-help" data-fit-quiz-width-help>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.2" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11.2V17M12 8.2v.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '<span>Help me find my width</span>' +
          '</button>' +
          '<button type="button" class="fit-quiz__chip" data-fit-quiz-skip>I\'m not sure yet</button>' +
          '</div>'
        : '';

      return (
        '<div class="fit-quiz__panel' +
        (isStart ? ' fit-quiz__panel--start' : ' fit-quiz__panel--ask') +
        '">' +
        (stepName
          ? '<p class="fit-quiz__step-name"><span class="fit-quiz__dot" aria-hidden="true"></span>' +
            escapeHtml(stepName) +
            '</p>'
          : '') +
        '<h2 class="fit-quiz__question" tabindex="-1" id="FitQuizQuestion-' +
        escapeAttr(question.id) +
        '">' +
        this.titleHtml(question.heading) +
        '</h2>' +
        (body ? '<p class="fit-quiz__body">' + escapeHtml(body) + '</p>' : '') +
        '<fieldset class="fit-quiz__choices fit-quiz__choices--count-' +
        count +
        (isStart ? ' fit-quiz__choices--start' : '') +
        (isMulti ? ' fit-quiz__choices--multi' : ' fit-quiz__choices--single') +
        '" aria-labelledby="FitQuizQuestion-' +
        escapeAttr(question.id) +
        '">' +
        '<legend class="visually-hidden">' +
        escapeHtml(question.heading) +
        '</legend>' +
        choices +
        '</fieldset>' +
        widthTools +
        (note
          ? '<p class="fit-quiz__note">' + this.sparkleMarkup() + '<span>' + escapeHtml(note) + '</span></p>'
          : '') +
        '</div>'
      );
    }

    statementMarkup(question) {
      var hero = (this.config.art && this.config.art.june_first) || '';
      var only = (question.choices || [])[0];
      var hiddenChoice = only
        ? '<input class="fit-quiz__input" type="radio" name="fit-quiz-' +
          escapeAttr(question.id) +
          '" value="' +
          escapeAttr(only.label) +
          '" data-fit-quiz-choice data-choice-id="' +
          escapeAttr(only.id) +
          '" checked>'
        : '';
      return (
        '<div class="fit-quiz__panel fit-quiz__panel--statement">' +
        hiddenChoice +
        this.artMarkup(hero, 'fit-quiz__art-frame--hero', true) +
        '<h2 class="fit-quiz__question" tabindex="-1" id="FitQuizQuestion-' +
        escapeAttr(question.id) +
        '">' +
        escapeHtml(question.heading) +
        '</h2>' +
        (question.body ? '<p class="fit-quiz__body">' + escapeHtml(question.body) + '</p>' : '') +
        '</div>'
      );
    }

    emailMarkup(question) {
      var id = 'FitQuizEmail-' + this.config.sectionId;
      var consentId = 'FitQuizConsent-' + this.config.sectionId;
      return (
        '<form class="fit-quiz__panel fit-quiz__panel--email" data-fit-quiz-email novalidate>' +
        '<h2 class="fit-quiz__question" tabindex="-1" id="FitQuizQuestion-' +
        escapeAttr(question.id) +
        '">' +
        escapeHtml(question.heading) +
        '</h2>' +
        (question.body ? '<p class="fit-quiz__body">' + escapeHtml(question.body) + '</p>' : '') +
        '<div class="fit-quiz__field">' +
        '<label class="fit-quiz__label" for="' +
        id +
        '">Email</label>' +
        '<input id="' +
        id +
        '" class="fit-quiz__email" type="email" name="email" autocomplete="email" inputmode="email" required data-fit-quiz-email-input placeholder="' +
        escapeAttr(question.emailPlaceholder || 'you@email.com') +
        '" aria-describedby="FitQuizStatus-' +
        escapeAttr(this.config.sectionId) +
        '">' +
        '</div>' +
        '<label class="fit-quiz__consent" for="' +
        consentId +
        '">' +
        '<input id="' +
        consentId +
        '" type="checkbox" data-fit-quiz-consent required>' +
        '<span>' +
        escapeHtml(question.consentLabel || 'I agree to receive the results of the quiz.') +
        '</span>' +
        '</label>' +
        '<div class="fit-quiz__actions">' +
        '<button type="submit" class="fit-quiz__button">' +
        escapeHtml(question.submitLabel || 'See my frames') +
        '</button>' +
        '</div>' +
        '</form>'
      );
    }

    resultsUrl() {
      return this.state.redirectUrl || buildResultsUrl(this.config.resultsBase, this.state.filters);
    }

    productsSectionUrl() {
      var url = this.resultsUrl();
      var join = url.indexOf('?') >= 0 ? '&' : '?';
      return url + join + 'section_id=fit-quiz-results-products';
    }

    answerPills() {
      var pills = [];
      var answers = this.state.answers || {};
      Object.keys(answers).forEach(function (key) {
        if (key === 'email') return;
        (answers[key] || []).forEach(function (item) {
          if (item && item.label && pills.indexOf(item.label) === -1) pills.push(item.label);
        });
      });
      return pills.slice(0, 6);
    }

    showResults() {
      this._showingResults = true;
      this._emailFallback = false;
      this.renderResults();
    }

    renderResults() {
      var quizSteps = this.quizSteps();
      var stepCount = Math.max(quizSteps.length, 1);
      if (this.progressEl) this.progressEl.textContent = 'Your personal fit notes';
      if (this.kickerEl) this.kickerEl.textContent = 'Your personal fit notes';
      if (this.countEl) this.countEl.textContent = 'All dialed in';
      if (this.meterEl) this.meterEl.classList.add('is-done');
      if (this.segmentsEl) {
        var segs = '';
        var i;
        for (i = 1; i <= stepCount; i++) segs += '<span class="fit-quiz__seg is-done"></span>';
        this.segmentsEl.innerHTML = segs;
      }
      this.stepRoot.innerHTML = this.resultsMarkup();
      this.syncDock();
      this.setStatus('', false);
      this.announce('Looking like your kind of fit.');
      this.loadLiveProducts();
      var heading = this.stepRoot.querySelector('.fit-quiz__question');
      if (heading) heading.focus();
    }

    resultsMarkup() {
      var pills = this.answerPills()
        .map(function (label) {
          return '<span class="fit-quiz__pill">' + escapeHtml(label) + '</span>';
        })
        .join('');
      var emailId = 'FitQuizEmail-' + this.config.sectionId;
      var consentId = 'FitQuizConsent-' + this.config.sectionId;
      return (
        '<div class="fit-quiz__panel fit-quiz__panel--results">' +
        '<p class="fit-quiz__step-name"><span class="fit-quiz__dot" aria-hidden="true"></span>Your fit, by design</p>' +
        '<div class="fit-quiz__title-row">' +
        '<h2 class="fit-quiz__question" tabindex="-1">Looking like<br>your kind of fit.</h2>' +
        '<span class="fit-quiz__done" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" focusable="false"><path d="M5 10.4l3.2 3.2L15 6.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '</div>' +
        '<p class="fit-quiz__body">A few good directions, built around your answers.</p>' +
        '<div class="fit-quiz__pills">' +
        pills +
        '</div>' +
        '<div class="fit-quiz__products" data-fit-quiz-products></div>' +
        '<p class="fit-quiz__disclaimer">These frames come from the live catalog, filtered by your answers. Prescription and reader availability still need a catalog confirmation.</p>' +
        '<button type="button" class="fit-quiz__fresh" data-fit-quiz-reset>Start a fresh fit guide</button>' +
        '<form class="fit-quiz__panel fit-quiz__panel--email" data-fit-quiz-email hidden novalidate>' +
        '<h3 class="fit-quiz__question">Save my fit card</h3>' +
        '<p class="fit-quiz__body">We will email this shortlist and keep your answers on the profile.</p>' +
        '<div class="fit-quiz__field">' +
        '<label class="fit-quiz__label" for="' +
        emailId +
        '">Email</label>' +
        '<input id="' +
        emailId +
        '" class="fit-quiz__email" type="email" name="email" autocomplete="email" inputmode="email" required data-fit-quiz-email-input placeholder="' +
        escapeAttr(this.config.emailPlaceholder || 'you@email.com') +
        '">' +
        '</div>' +
        '<label class="fit-quiz__consent" for="' +
        consentId +
        '">' +
        '<input id="' +
        consentId +
        '" type="checkbox" data-fit-quiz-consent required>' +
        '<span>' +
        escapeHtml(this.config.emailConsentLabel || 'I agree to receive the results of the quiz.') +
        '</span>' +
        '</label>' +
        '<div class="fit-quiz__actions">' +
        '<button type="submit" class="fit-quiz__button">' +
        escapeHtml(this.config.emailSubmitLabel || 'See my frames') +
        '</button>' +
        '</div>' +
        '</form>' +
        '</div>'
      );
    }

    loadLiveProducts() {
      var mount = this.stepRoot.querySelector('[data-fit-quiz-products]');
      if (!mount) return;
      var self = this;
      fetch(this.productsSectionUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('section');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nodes = doc.querySelectorAll('[data-fit-quiz-product]');
          if (!nodes.length) {
            if (self.renderPreviewProducts(mount)) return;
            self.renderCatalogFallback(mount);
            return;
          }
          var cards = '';
          nodes.forEach(function (node, index) {
            cards += self.productCardHtml(
              {
                title: node.getAttribute('data-title'),
                url: node.getAttribute('data-url'),
                image: node.getAttribute('data-image'),
                help: node.getAttribute('data-help'),
              },
              index
            );
          });
          mount.innerHTML = cards;
        })
        .catch(function () {
          if (self.renderPreviewProducts(mount)) return;
          self.renderCatalogFallback(mount);
        });
    }

    renderPreviewProducts(mount) {
      var products = this.config.previewProducts || [];
      if (!mount || !products.length) return false;
      var self = this;
      mount.innerHTML = products
        .slice(0, 3)
        .map(function (product, index) {
          return self.productCardHtml(product, index);
        })
        .join('');
      return true;
    }

    renderCatalogFallback(mount) {
      if (!mount) return;
      mount.innerHTML = this.productCardHtml(
        {
          title: 'See your filtered frames',
          url: this.resultsUrl(),
          image: '',
          help: 'Your answers are saved as Search and Discovery filters. Open the live collection to shop real inventory.',
        },
        0
      );
    }

    productCardHtml(product, index) {
      var kicker = this.padStep(index + 1) + (index === 0 ? ' / Start here' : ' / Also your style');
      return (
        '<a class="fit-quiz__product-card" href="' +
        escapeAttr(product.url || this.resultsUrl()) +
        '">' +
        '<div class="fit-quiz__product-top"><span>' +
        escapeHtml(kicker) +
        '</span><span class="fit-quiz__product-heart" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 20s-7-4.4-7-9.2C5 8 6.8 6.4 9 6.4c1.3 0 2.4.6 3 1.6.6-1 1.7-1.6 3-1.6 2.2 0 4 1.6 4 4.4C19 15.6 12 20 12 20z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>' +
        '</span></div>' +
        (product.image
          ? '<img alt="" src="' + escapeAttr(product.image) + '" width="800" height="400">'
          : '') +
        '<h3>' +
        escapeHtml(product.title || 'Madson frame') +
        '</h3>' +
        '<p>' +
        escapeHtml(product.help || 'A direction based on the answers you liked.') +
        '</p>' +
        '<span>Take a closer look →</span>' +
        '</a>'
      );
    }

    saveFitCard() {
      var form = this.stepRoot.querySelector('[data-fit-quiz-email]');
      if (!form) return;
      form.hidden = false;
      var input = form.querySelector('[data-fit-quiz-email-input]');
      if (input) input.focus();
    }

    openSheet(kind) {
      if (!this.sheetEl) return;
      if (this.sheetBodyEl) {
        this.sheetBodyEl.textContent =
          kind === 'width'
            ? 'Use a best guess. Narrow means standard frames feel roomy. Medium feels about right. Wide feels snug. Extra wide is the XL you already look for.'
            : 'Six quick questions. Pick a collection, then width, shape, feel, issues, and lenses. The primary button stays off until you have an answer.';
      }
      this.sheetEl.hidden = false;
    }

    closeSheet() {
      if (this.sheetEl) this.sheetEl.hidden = true;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  customElements.define('fit-quiz', FitQuiz);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('fit-quiz');
    if (!root || typeof root.resetFromEditor !== 'function') return;
    root.resetFromEditor();
  });
})(typeof window !== 'undefined' ? window : globalThis);
